import { createSlice } from "@reduxjs/toolkit";
// import { apiCallBegan } from "./api";

const slice = createSlice({
  name:'airtable',
  initialState:{
    bases: [],
    data:{}
  },
  reducers:{
    setAirtableBase:(airtable,action)=>{
      airtable.bases = action.payload;
    },
    setAirtableData:(airtable,action)=>{
      airtable.data = action.payload;
    }
  }
})
// console.log(slice);
export const { setAirtableBase,setAirtableData } = slice.actions;
export default slice.reducer;